import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "@/includes/_icons.scss";
import "@/includes/_buttons.scss";
import "@/includes/_indent.scss";
import "@/includes/_classes.scss";
import "primevue/resources/themes/aura-light-green/theme.css";
import "flag-icons/css/flag-icons.min.css";
import { createApp } from "vue";
import App from "./App.vue";
import router from "@/router";
import store from "@/store";
import axios from "axios";
import VueAxios from "vue-axios";
import VueCookies from "vue3-cookies";
import lib from "@/includes/lib.js";
import i18n from "./i18n";
import { create, all } from "mathjs";
import PrimeVue from "primevue/config";
import { loadRuntimeEnvironment } from "@/includes/runtimeEnvironment";

axios.defaults.baseURL = "/api";

axios.interceptors.response.use(
  function (res) {
    lib.res(res, store, router);
    return res;
  },
  function (error) {
    // lib.err уже показывает пользователю ошибку (тост) и гасит лоадер.
    lib.err(error, store, router);
    // Помечаем ошибку как уже обработанную интерцептором, чтобы глобальный
    // обработчик unhandledrejection (ниже) не дублировал её в консоль.
    if (error && typeof error === "object") {
      error.handledByInterceptor = true;
    }
    // Отклоняем промис: success-колбэки .then() пропускаются, поэтому
    // success-логика не выполняется на упавшем запросе и нет
    // «TypeError: Cannot read properties of undefined» в .then(res => res.data...).
    return Promise.reject(error);
  }
);

// Ошибки axios, прошедшие через интерцептор выше, уже показаны пользователю в
// lib.err. Если у конкретного .then() нет своего .catch(), отклонение всплывает
// как unhandledrejection — гасим только такой (помеченный) шум в консоли, не
// скрывая прочие настоящие необработанные отклонения (баги в коде).
window.addEventListener("unhandledrejection", function (event) {
  const reason = event.reason;
  if (reason && typeof reason === "object" && reason.handledByInterceptor) {
    event.preventDefault();
  }
});

axios.interceptors.request.use(
  function (req) {
    lib.req(req, store, router);
    return req;
  },
  function (error) {
    return Promise.reject(error);
  }
);

router.beforeEach((to, from, next) => {
  if (to.href == "/logout") {
    store.dispatch("logout", router);
  } else {
    next();
  }
});

const math = create(all, {});

function bootstrap() {
  const Vue = createApp(App)
  .use(i18n)
  .use(store)
  .use(router)
  .use(VueAxios, axios)
  .use(VueCookies)
  .use(PrimeVue)

  Vue.config.globalProperties.$math = math;
  Vue.config.globalProperties.$lib = lib;
  Vue.mount("#app");

  loadRuntimeEnvironment().then((runtimeEnvironment) => {
    store.commit('RUNTIME_ENVIRONMENT', runtimeEnvironment);
  });
}

bootstrap();

import "bootstrap/dist/js/bootstrap.js";
import "./registerServiceWorker";
